import api from '@/api'
import { sortBy } from 'lodash'

export default {
  namespaced: true,

  state: () => ({
    data: []
  }),

  actions: {
    get: async function (ctx, params) {
      const response = await api.get(`/v1/inputs`, params)

      ctx.commit('set', response.data)
    }
  },

  mutations: {
    set: function (state, inputs) {
      const data = inputs.map(input => ({ name: input.name, _id: input._id }))
      state.data = sortBy(data, 'name')
    },
    reset: function (state) {
      state.data = []
    }
  }
}
